import { apiHost } from '@libs/providers/api-host.provider';

const apiUrl = `${apiHost()}/web/redirects/match`;

export async function getMatchingRedirect(url: string): Promise<string | null> {
    try {
        const query = new URLSearchParams({
            url: url,
        });
        const response = await fetch(`${apiUrl}?${query}`, {
            method: 'GET',
            headers: {"Content-Type": "application/json"},
        });
        const data = await response.json();
        return data.to;
    } catch (e) {
        return null;
    }
}
